export const jumpTo = ($router, fullLink) => {
  const link = '/' + fullLink.split('/').slice(3).join('/')

  // const arr = $router.getMatchedComponents(link) || []
  if (fullLink.indexOf(document.domain) >= 0) {
    $router.push(link)
  } else {
    // window.open(fullLink)
    window.location.href = fullLink
  }
}
